"use client";

import React from "react";

function usePlatformDetector() {
  const [platform, setPlatform] = React.useState({
    isAndroid: false,
    isIOS: false,
  });

  React.useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    setPlatform({
      isAndroid: /android/i.test(userAgent),
      isIOS: /iphone|ipad|ipod/i.test(userAgent),
    });
  }, []);

  return {
    isMobile: platform.isAndroid || platform.isIOS,
    ...platform,
  };
}

export default usePlatformDetector;
